/**
 * Link imports in the operators' language: the phase shown while an imported asset is still
 * `uploading`, and the reason shown when an import cannot start. Pure; tested in intakePhase.test.ts.
 */
export type IntakeView = { stagedAt?: number; copyJobId?: string };

export function intakePhaseLabel(asset: { transcodingStatus: string; intake?: IntakeView | null }): string | undefined {
  if (asset.transcodingStatus !== 'uploading' || !asset.intake) return undefined;
  if (asset.intake.copyJobId) return 'Copiando a la biblioteca';
  if (asset.intake.stagedAt) return 'Recibido';
  return 'Recibiendo';
}

function waitText(seconds: number | undefined): string {
  if (seconds === undefined || !Number.isFinite(seconds) || seconds <= 0) return 'en unos minutos';
  const minutes = Math.ceil(seconds / 60);
  return minutes <= 1 ? 'en un minuto' : `en ${minutes} minutos`;
}

export function linkImportErrorMessage(code: string | undefined, retryAfterSeconds?: number): string {
  switch (code) {
    case 'link_invalid':
      return 'El enlace debe comenzar con https:// y no puede incluir usuario ni contraseña.';
    case 'intake_disabled':
      return 'La importación desde enlaces no está activada.';
    case 'intake_misconfigured':
      return 'La importación desde enlaces no está configurada. Avisa al equipo técnico.';
    case 'tenant_concurrency_exceeded':
      return `Hay demasiadas importaciones en curso. Intenta de nuevo ${waitText(retryAfterSeconds)}.`;
    case 'quota_exceeded':
      return `Se alcanzó el límite diario de importaciones. Intenta de nuevo ${waitText(retryAfterSeconds)}.`;
    case 'service_unavailable':
      return `El servicio de importación no responde. Intenta de nuevo ${waitText(retryAfterSeconds)}.`;
    case undefined:
      return 'No se pudo iniciar la importación.';
    default:
      return `No se pudo iniciar la importación (código: ${/^[a-z0-9_]{1,64}$/.test(code) ? code : 'desconocido'}).`;
  }
}
